// src/pages/ServiceDetailsPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import { softwareDevelopmentData } from "../data/softwareDevelopmentData";
import ContactFormModal from '../components/common/ContactFormModal';


export default function ServiceDetailsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { id } = useParams();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  console.log("^^^"+ softwareDevelopmentData);
  const service = softwareDevelopmentData.find((item) => item.id === parseInt(id));
  if (!service) {
    return (
      <div className="text-center py-20">
        <h1 className="text-2xl font-bold">Service WWWNot Found</h1>
      </div>
    );
  }

  const handleNextService = () => {
    const currentIndex = softwareDevelopmentData.findIndex(
      (item) => item.id === Number(id)
    );
    if (currentIndex === -1) return;

    const nextService = softwareDevelopmentData[currentIndex + 1];
    if (nextService) {
      navigate(`/services/${nextService.id}`);
    } else {
      navigate(`/services/${softwareDevelopmentData[0].id}`);
    }
  };

  return (
    <div className="bg-white text-gray-800">
      <Header />

      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-r from-[#264864] to-[#35a89d] text-white text-center mt-20">
        <h1 className="text-5xl font-extrabold">{service.title}</h1>
      </section>

      {/* Sub Header */}
      <section className="py-20 bg-gradient-to-r from-[#35a89d] to-[#264864] text-white">
        <div className="grid md:grid-cols-2 gap-28 items-center max-w-7xl mx-auto px-6 md:px-12">
          <div>
            <h2 className="text-4xl font-bold mb-8">
              {service.sub_headers.title}
            </h2>
            <ul className="list-disc pl-6 space-y-4 text-lg mb-8">
              {service.sub_headers.sub_points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          <Link
            onClick={() => setIsModalOpen(true)}
            className="inline-block bg-transparent text-white border-2 border-white px-6 py-3 rounded-none font-bold shadow hover:bg-white hover:text-black transition-colors duration-300"
          >
            Request a Quote
          </Link>


          </div>
          <img
            src={service.sub_headers.mockupImage}
            style={{ maxHeight: "400px" }}
            alt="about mockup"
            className="rounded-lg shadow-xl"
          />
        </div>
      </section>
      <ContactFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      {/* Our Process */}
        <section className="py-20 bg-white text-gray-800">
            <h2 className="text-4xl font-bold text-center mb-14 text-gray-900">Our Process</h2>
            <div className="grid md:grid-cols-4 gap-12 max-w-7xl mx-auto px-10">
                {service.process.map((step) => (
                    <div key={step.id} className="p-8 bg-white text-gray-800 shadow-lg text-center">
                        <div className="mb-4">
                            <span
                            style={{
                                WebkitTextStroke: "2px #3b82f6",
                                color: "transparent",
                                fontSize: "3rem",
                                fontWeight: "800",
                                letterSpacing: "0.1em",
                            }}
                            >
                            {`0${step.id}`}
                            </span>
                        </div>
                        <h3 className="font-bold text-2xl mb-6">{step.title}</h3>
                        <p className="text-lg">{step.description}</p>
                    </div>
                ))}
            </div>
        </section>

{/* The Problem We Solve */}
<section className="py-20 bg-gradient-to-r from-[#264864] to-[#1e3a5f] text-white">
  <h2 className="text-4xl font-bold text-center mb-14">The Problem We Solve</h2>
  <div className="grid md:grid-cols-2 gap-20 items-center max-w-7xl mx-auto px-10">
    {/* Text Right, Image Left */}
    <img
      src={service.problem.mockupImage}
      alt="challenge"
      className="rounded-lg shadow-xl"
    />
    <ul className="list-disc pl-6 space-y-4 text-lg">
      {service.problem.challenges.map((c, i) => (
        <li key={i}>{c}</li>
      ))}
    </ul>
  </div>
</section>

{/* Our Solution */}
<section className="py-20 bg-gradient-to-r from-[#35a89d] to-[#2d7c74] text-white">
  <h2 className="text-4xl font-bold text-center mb-14">Our Solution</h2>
  <p className="max-w-4xl mx-auto text-center mb-12 text-lg">{service.solutions.desc}</p>
  <div className="grid md:grid-cols-2 gap-20 items-center max-w-7xl mx-auto px-10">
    {/* Text Left, Image Right */}
    <ul className="list-disc pl-6 space-y-4 text-lg">
      {service.solutions.points.map((p, i) => (
        <li key={i}>{p}</li>
      ))}
    </ul>
    <img
      src={service.solutions.mockupImage}
      style={{ maxHeight: "400px" }}
      alt="solution"
      className="rounded-lg shadow-xl"
    />
  </div>
</section>

{/* Key Benefits */}
<section className="py-20 bg-gradient-to-r from-[#264864] to-[#1e3a5f]">
  <div className="max-w-5xl mx-auto px-10 bg-white shadow-lg py-16">
    <h2 className="text-4xl font-bold text-center mb-14 text-gray-800">
      Key Benefits
    </h2>
    <p className="max-w-3xl mx-auto text-center mb-12 text-lg text-gray-700">
      {service.benefits.desc}
    </p>
    <div className="flex flex-wrap justify-center gap-10">
      {service.benefits.metrics.map((m, i) => {
        const match = m.value.match(/(\d+\.?\d*)(.*)/);
        const number = match ? match[1] : m.value;
        const percent = match ? match[2] : "";

        return (
          <div
            key={i}
            className="w-full md:w-[calc(50%-20px)] p-8 border border-gray-200 shadow text-center"
          >
            <p className="font-bold text-lg mb-2">{m.title}</p>
            <p className="text-5xl font-extrabold bg-gradient-to-br from-blue-900 via-blue-600 to-blue-300 text-transparent bg-clip-text">
              {number}
              {percent && (
                <span className="text-3xl align-top"> {percent}</span>
              )}
            </p>
            {m.extra && (
              <p className="text-lg mt-2 text-gray-800">{m.extra}</p>
            )}
          </div>
        );
      })}
    </div>
  </div>
</section>

    {/* Features */}
    <section className="py-20 bg-white text-gray-800">
      <h2 className="text-4xl font-bold text-center mb-14 text-gray-900">Key Features</h2>
      <div className="grid md:grid-cols-2 gap-12 max-w-7xl mx-auto px-10">
        {service.features.map((feature) => {
          const formattedId = feature.id < 10 ? `0${feature.id}.` : `${feature.id}.`;

          return (
            <div
              key={feature.id}
              className="p-8 bg-white text-gray-800 shadow-lg"
            >
              {/* Feature ID as outlined number */}
              <div className="mb-4">
                <span
                  style={{
                    WebkitTextStroke: "2px #3b82f6", // light blue stroke
                    color: "transparent",          // fill transparent
                    fontSize: "3rem",
                    fontWeight: "800",
                    letterSpacing: "0.1em",
                  }}
                >
                  {formattedId}
                </span>
              </div>

              {/* Feature Title */}
              <h3 className="font-bold text-2xl mb-6">{feature.title}</h3>

              {/* Sub-features */}
              <ul className="list-disc pl-6 space-y-3 text-lg">
                {feature.sub_features.map((sf, j) => (
                  <li key={j}>{sf}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </section>

    {/* Technologies */}
    <section className="py-20" style={{ backgroundColor: "#f0f8ff" }}>
      <h2 className="text-4xl font-bold text-center mb-14 text-gray-900">Technologies</h2>
      <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto px-10">
        {service.technologies.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-8 bg-white p-6 rounded-lg shadow"
          >
            <div className="text-black font-extrabold text-3xl">
              {t.icon}
            </div>
            <span className="font-bold text-gray-900">{t.name}</span>
          </div>
        ))}
      </div>
    </section>

    {/* Testimonials */}
    <section className="py-20 bg-[#f8f9fa]">
        <h2 className="text-4xl font-bold text-center mb-14">Testimonials</h2>
        <div className="max-w-7xl mx-auto space-y-10 px-6">
            {service.testimonials && service.testimonials.length > 0 && (
                service.testimonials.map((testimonial) => (
                <div
                    key={testimonial.id}
                    className="flex flex-col md:flex-row items-start border-2 border-blue-500 rounded-lg p-6 bg-white"
                >
                    <div className="flex-1 text-center">
                    <h3 className="font-bold text-xl">{testimonial.author}</h3>
                    <p className="text-blue-600 font-semibold mb-4">{testimonial.title}</p>
                    <p className="text-gray-800 text-lg leading-relaxed">{testimonial.quote}</p>
                    </div>
                </div>
                ))
            )}
        </div>
    </section>

    {/* FAQ */}
    <section className="py-20 bg-white">
        <h2 className="text-4xl font-bold text-center mb-14">Frequently Asked Questions</h2>
        <div className="max-w-4xl mx-auto">
            {service.faq.map((faqItem) => (
                <div key={faqItem.id} className="mb-4">
                    <h3 className="font-bold text-xl mb-2">{faqItem.question}</h3>
                    <p className="text-gray-600">{faqItem.answer}</p>
                </div>
            ))}
        </div>
    </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-[#264864] to-[#35a89d] text-center text-white">
        <h2 className="text-4xl font-bold mb-10">
          Let’s start. It’s easier than you think.
        </h2>
        <div className="flex justify-center space-x-8">
          <Link
            to="/request-demo"
            className="bg-white text-[#264864] px-8 py-4 rounded-lg font-bold shadow inline-block text-center"
          >
            Contact Us
          </Link>
          <button
            onClick={handleNextService}
            className="border border-white px-8 py-4 rounded-lg font-bold"
          >
            Next Service →
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
